document.addEventListener("DOMContentLoaded", function () {
	const button = document.getElementById("userway-fab");
	const loader = document.getElementById("userway-fab-loader");
	const label = document.getElementById("userway-fab-label");

	function setLoading(state) {
		if (state) {
			loader.style.display = "flex"; // show loader
			label.style.display = "none"; // hide label
		} else {
			loader.style.display = "none"; // hide loader
			label.style.display = "flex"; // show label
		}
	}

	// MutationObserver to detect UserWay widget ready state
	const bodyObserver = new MutationObserver((mutationsList, observer) => {
		for (const mutation of mutationsList) {
			for (const node of mutation.addedNodes) {
				if (node.nodeType === 1 && node.matches("div.uwy")) {
					// Watch class changes on the UserWay widget
					const widgetObserver = new MutationObserver((muts) => {
						for (const mut of muts) {
							if (mut.type === "attributes" && mut.attributeName === "class") {
								if (mut.target.classList.contains("uon")) {
									setLoading(false); // widget ready
								}
							}
						}
					});
					widgetObserver.observe(node, {
						attributes: true,
						attributeFilter: ["class"],
					});
					observer.disconnect(); // stop observing body
				}
			}
		}
	});

	bodyObserver.observe(document.body, { childList: true, subtree: true });

	// Button click
	button.addEventListener("click", function () {
		setLoading(true);
		if (window.UserWay && typeof window.UserWay.widgetToggle === "function") {
			window.UserWay.widgetToggle();
		}
	});
});
